import { useState, useEffect } from "react";
import moment from 'moment';
var interval
export const countdown = (element, minutes, seconds, setValue) => {
    // console.log("el", element);
    var time = minutes * 60 + seconds;
    interval = setInterval(function () {
        var el = document.getElementById(element);
        if (time <= 0) {
            setValue("Resend")
            clearInterval(interval);
            return;
        }
        var minutes = Math.floor(time / 60);
        if (minutes < 10) minutes = "0" + minutes;
        var seconds = time % 60;
        if (seconds < 10) seconds = "0" + seconds;
        var text = minutes + ':' + seconds;
        el.innerHTML = text;
        time--;
    }, 1000);
}
export function stopTimer() {
    clearInterval(interval);
    // GO RIGHT;
}

export const generateUrl = (url) => {
    return window.url + url;
}

export const GetRequest = async (url) => {
    try {
        const response = await fetch(generateUrl(url));
        try {
            return await response.json();
        } catch (error) {
            return false;
        }
    }
    catch (err) {
        return err;
    }
}

export function useFetch(url) {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    async function fetchUrl() {
        const response = await fetch(url);
        const json = await response.json();
        setData(json);
        setLoading(false);
    }
    useEffect(() => {
        fetchUrl();
    }, []);
    return [data, loading];
}
export const PostRequest = async (url, postData) => {
    let body = new FormData();
    Object.keys(postData).forEach(el => {
        body.append(el, typeof (postData[el]) == "string" ? postData[el] : JSON.stringify(postData[el]));
    })
    try {
        const response = await fetch(generateUrl(url), {
            method: "POST",
            body
        });
        try {
            return await response.json();
        } catch (error) {
            return false;
        }
    }
    catch (error) {
        return error;
    }

}

export const PostRequestFile = async (url, postData) => {
    let body = new FormData();
    Object.keys(postData).forEach(el => {
        if(el=="file" && postData[el]){
            // console.info(el)
            // console.info(postData[el])
            body.append(el, postData[el])
        }else
        body.append(el, typeof (postData[el]) == "string" ? postData[el] : JSON.stringify(postData[el]));
    })

    try {
        const response = await fetch(generateUrl(url), {
            method: "POST",
            body
        });
        try {
            return await response.json();
        } catch (error) {
            return false;
        }
    }
    catch (error) {
        return error;
    }

}

export function getSearchParams() {
    const myObj = {};
    const param = decodeURIComponent(window.location.search).split('?').length > 1 ? decodeURIComponent(window.location.search).split('?')[1] : false;
    const pairs = param ? param.split('&') : [];
    for (let i = 0; i < pairs.length; i++) {
        pairs[i] = pairs[i].split('=');
        myObj[pairs[i][0]] = pairs[i][1];
    }
    return myObj;
}

/* -------------- DATE FORMAT START -------------- */
/*
    t => date --- 09, 21 etc
    d => days in small --- Sun, Mon etc
    D => days in big --- Sunday, Monday etc
    m => months in small --- Jan, Feb etc
    M => months in big --- January, February etc
    y => years in small --- 19, 18 etc
    Y => years in big --- 2019, 2018 etc
    h => hours in 12 hrs format --- 01 - 12
    H => hours in 24 hrs format --- 09, 19 etc
    i => minutes --- 22, 03
    s => seconds --- 22, 03
    a => am/pm in small --- am, pm
    A => AM/PM in small --- AM, PM

*/
/* -------------- DATE FORMAT END -------------- */

export const monthsFull = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
export const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const daysFull = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
export const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const isLeapYr = (year) => (year || new Date().getFullYear()) % 4 === 0;
export const noOfDays = (year) => [31, (isLeapYr(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
export const monthDates = (month, year) => noOfDays(year)[month];
export const prefixZero = (val) => (val + "").length === 1 ? "0" + val : val;

export const getDaysInMonth = (month, year, param = 0) => {
    const days = [];
    const firstDay = new Date(year, month, 1).getDay() + param;
    for (let i = 0; i < firstDay; i++) {
        days.push(false);
    }
    const totalDays = monthDates(month, year);
    for (let i = 1; i <= totalDays; i++) {
        days.push(i);
    }
    return days;
}

export const getFormat = (date, format) => {
    date = new Date(date);
    if (!date) {
        return "Invalid date format";
    }
    let returnDate = "";
    format = format.split("");
    format.forEach(el => {
        returnDate += getFormatHelper(el, date);
    });
    return returnDate;
}


const getFormatHelper = (param, date) => {
    const day = date.getDay();
    const month = date.getMonth();
    const year = date.getFullYear();
    const hours = date.getHours();
    switch (param) {
        case "d":
            return days[day];
        case "D":
            return daysFull[day];
        case "m":
            return months[month];
        case "M":
            return monthsFull[month];
        case "y":
            return (year + "").substring(2, 4);
        case "Y":
            return year;
        case "h":
            return (hours > 12 ? prefixZero(hours - 12) : (hours === 0 ? 12 : prefixZero(hours)));
        case "H":
            return prefixZero(hours);
        case "i":
            const min = date.getMinutes();
            return prefixZero(min);
        case "s":
            const sec = date.getSeconds();
            return prefixZero(sec);
        case "a":
            return (hours >= 12 ? "pm" : "am");
        case "A":
            return (hours >= 12 ? "PM" : "AM");
        case "t":
            const dt = date.getDate();
            return prefixZero(dt);
        default:
            return param;
    }
}


export function get24HoursTimeNew(val) {
    var date = new Date(val);
    return moment(date, 'YYYY-MM-DD hh:mm:ss a').format("HH:mm");
}

export const handleImgError = (e) => {
    e.target.style = 'display:none'
}

export const getImgPath = (path) => window.imgPath + path;
